import { quickSightVizFn } from '../components/Visualization/quickSightEmbedAPILoader';
import { Error } from '../ErrorHandling';
import { Resource } from '../Resource/Types';

export interface VisualizationToken {
  value: string;
}

export type VisualizationTokenResource = Resource<VisualizationToken>;

export type State = Waiting | Loading | Ready | Error;

export type VisualizationFunction = quickSightVizFn;

export interface Waiting {
  kind: 'waiting';
}

export interface Loading {
  kind: 'loading';
}

export interface Ready {
  kind: 'ready';
  visualizationToken: VisualizationToken;
}

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const loading = (): Loading => ({
  kind: 'loading',
});

export const ready = (visualizationToken: VisualizationToken): Ready => ({
  kind: 'ready',
  visualizationToken,
});
